<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="MetricWidget" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { useChangableProps } from '@/composables/useChangableProps';
import GravManagerWrapper from './GravManagerWrapper.vue';
import { MetricWidgetProps } from './MetricWidget.ts';
import MetricWidget from './MetricWidget.vue';

const componentName = 'ui-metric-widget';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<MetricWidgetProps>();
const changableProps = useChangableProps(componentName, props);

</script>
